module.exports = __webpack_public_path__ + "img/emporte-piece-coeur-ex-voto-ailes.1e300545.jpg";